import "./App.css";
import ContactUs from "./Components/ContectUs/ContectUs";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import WhoWeAre from "./Components/AboutUs/AboutUs";
import PackagesComponent from "./Components/OurPackages/Packages";
import Screenfirst from "./SCREEMS/Screenfirst";
import React from "react";
import BookingPage from "./Components/BookingPage"; // Import the new Booking Page component
import WhatsAppButton from "./Components/WhatsappButton";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Screenfirst />} />
          <Route path="/packages" element={<PackagesComponent />} />
          <Route path="/about-us" element={<WhoWeAre />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/booking" element={<BookingPage />} /> {/* New Route */}
        </Routes>
        <Footer />
        <WhatsAppButton />
      </Router>
    </>
  );
}

export default App;
